import Route from '@ember/routing/route';
import type RoutingService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';

export default class IndexRoute extends Route {
  @service declare router: RoutingService;
  beforeModel(): void {
    // Ensure the presence of the terminal slash in the URL
    let url = window.location.href;
    let queryIndex = url.indexOf('?');
    if (queryIndex === -1) {
      queryIndex = url.length;
    }
    if (url[queryIndex - 1] !== '/') {
      let newUrl = url.substring(0, queryIndex) + '/' + url.substring(queryIndex);
      window.history.replaceState({}, '', newUrl);
    }
    this.router.transitionTo('photodiode'); // Implicitly aborts the on-going transition.
  }
}
